import React from 'react';
import { Button } from './ui/button';
import { Phone, Clock, Globe, Shield, FileCheck } from 'lucide-react';
import { useContact } from '../context/ContactContext';
import { COMPANY } from '../data/company';

export const HeroSection = () => {
  const { openContactForm } = useContact();
  return (
    <section className="relative bg-gradient-to-br from-blue-50 to-orange-50 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Keep Your Wheels Turning.
            <span className="block text-orange-600">We Keep You Loaded.</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-700 mb-12 max-w-4xl mx-auto leading-relaxed">
            Flow Fleet Solutions finds the best-paying loads, negotiates strong rates, 
            and handles the paperwork—so you can drive and get paid.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Button size="lg" onClick={() => (window.location.href = COMPANY.phoneHref)} className="bg-orange-600 hover:bg-orange-700 text-white text-lg px-8 py-4 flex items-center gap-2" data-testid="hero-call-btn">
              <Phone className="h-5 w-5" />
              Call Now: {COMPANY.phoneDisplay}
            </Button>
            <Button size="lg" variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white text-lg px-8 py-4" onClick={openContactForm} data-testid="hero-get-dispatched-btn">
              Get Dispatched Today
            </Button>
          </div>
          
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 max-w-4xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="flex flex-col items-center text-center">
                <Clock className="h-8 w-8 text-blue-600 mb-2" />
                <span className="font-semibold text-gray-900">24/7 Dispatch</span>
              </div>
              <div className="flex flex-col items-center text-center">
                <Globe className="h-8 w-8 text-blue-600 mb-2" />
                <span className="font-semibold text-gray-900">Nationwide Coverage</span>
              </div>
              <div className="flex flex-col items-center text-center">
                <Shield className="h-8 w-8 text-blue-600 mb-2" />
                <span className="font-semibold text-gray-900">Broker Credit Checks</span>
              </div>
              <div className="flex flex-col items-center text-center">
                <FileCheck className="h-8 w-8 text-blue-600 mb-2" />
                <span className="font-semibold text-gray-900">Fast Paperwork</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};